import { render, staticRenderFns } from "./GtImage.vue?vue&type=template&id=c57d83ac&scoped=true&"
import script from "./GtImage.vue?vue&type=script&lang=ts&"
export * from "./GtImage.vue?vue&type=script&lang=ts&"
import style0 from "./GtImage.vue?vue&type=style&index=0&id=c57d83ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57d83ac",
  null
  
)

export default component.exports